import { FC } from 'react';
import { Trans } from 'react-i18next';
import BackSpace from '../../assets/backspace.png'; // adjust the path if necessary
import ActiveCheck from '../../assets/active_check.png'; // adjust the path if necessary
import InactiveCheck from '../../assets/inactive_check.png'; // adjust the path if necessary
import { PinInputProps } from './tabletPinInput.type';
import './tabletPinInput.css';
import Loading from '../../assets/loading/loading';
import { numberPad } from '../../utils/constant';

const TabletPinInput: FC<PinInputProps> = (props) => {
  const idPrefix = 'tablet-pin-input';
  const otpLength: number = props.otpLength || 6;
  const handleNumberClick = (num: string) => {
    if (!props.setPin) return;
    if ((props.pin?.length ?? 0) < otpLength) {
      props.setPin((props.pin ?? '') + num);
    }
  };

  const handleBackspace = () => {
    if (!props.setPin) return;
    if (props.pin && props.pin.length > 0) {
      const updatedPin: string = props.pin.slice(0, -1);
      props.setPin(updatedPin);
    }
  };

  return (
    <div className="flex flex-col items-center" id="tablet-pin-input-root">
      <div className="flex space-x-7">
        {Array.from({ length: otpLength }).map((_, idx) => (
          <div
            key={idx}
            id={`pin-dot-${idx}`}
            data-testid={`${idPrefix}-dot-${idx}`}
            className={`number-selected-container ${
              props.pin && idx < props.pin.length
                ? 'bg-THEME_COLOR'
                : 'bg-gray-300'
            }`}
          />
        ))}
      </div>

      <div className="flex flex-col items-center">
        <div className="number-contain">
          {numberPad.map((num: string) => (
            <button
              key={num}
              type="button"
              id={`num-btn-${num}`}
              onClick={() => handleNumberClick(num)}
              className="number-button"
            >
              {num}
            </button>
          ))}

          <div id="backspace-btn" onClick={handleBackspace}>
            <img
              src={BackSpace}
              alt="Backspace"
              className="md:w-18 md:h-14 w-18 h-18"
            />
          </div>

          <button
            type="button"
            id="num-btn-0"
            onClick={() => handleNumberClick('0')}
            className="number-button"
          >
            0
          </button>

          {props.pin?.length === otpLength ? (
            props.isVerifyLoading ? (
              <div
                className="mt-4 ml-5"
                id="verify-loading"
                data-testid="verify-loading"
              >
                <Loading height={30} width={30} />
              </div>
            ) : (
              <div
                className="cursor-pointer"
                id="verify-btn"
                onClick={props.handleVerifyOtp}
              >
                <img
                  src={ActiveCheck}
                  alt="Active Check"
                  className="md:w-14 md:h-14 w-18 h-18"
                />
              </div>
            )
          ) : (
            <img
              src={InactiveCheck}
              alt="Inactive Check"
              id="inactive-check"
              className="md:w-14 md:h-14 w-18 h-18"
            />
          )}
        </div>

        {props.error && (
          <p
            className="text-base text-[#D80000] mt-3 ml-1"
            id="pin-error"
            data-testid={props.otpErrorTestId || 'otp-error'}
          >
            {props.error}
          </p>
        )}

        <button
          onClick={props.handleAuthClick}
          type="button"
          id="forgot-pin-btn"
          data-testid={props.forgotPinTestId || 'forgot-pin-auth'}
          className="text-[#000000] text-2xl md:text-xl mt-6 md:mt-2 font-helvetica"
        >
          {<Trans i18nKey={props.authText} />}
        </button>
      </div>
    </div>
  );
};

export default TabletPinInput;
